export type { ContentTextProps } from './ContentText';
export { default as ContentText } from './ContentText';
